import { Link } from 'react-router-dom'

// Плашка над таблицей позиций, когда карточку открыли из уведомления.
export function NotificationFocusBanner({
  itemId,
  focusKind,
}: {
  itemId: string
  focusKind: string | null
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-brand-100 bg-brand-50 px-3 py-2 text-sm text-brand-900">
      <span>Открыт контекст уведомления: позиция подсвечена в таблице.</span>
      <Link
        to={`/request-items/${itemId}${focusKind ? `?focus=${focusKind}` : ''}`}
        className="rounded-md bg-white px-2.5 py-1 text-xs font-medium text-brand-700 hover:bg-brand-100"
      >
        Открыть позицию
      </Link>
    </div>
  )
}
